<template>
<div>
<!--  单独普通的矩形管道写法-->
<!--  <div :style="style" class="cross" v-if="mode === 'edit'">-->
<!--    <div class="rowx">-->
<!--      <div class="row1x" :style="style"></div>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div :style="style" @click="handleClick" class="cross" v-if="realtimeData.state===true && mode === 'view'">-->
<!--    <div class="rowx">-->
<!--      <div class="row1x" :style="style"></div>-->
<!--    </div>-->
<!--  </div>-->
  <div :style="style" class="cross" v-if="mode === 'edit'">
  </div>
  <div :style="style" @click="handleClick" class="cross" v-if="realtimeData.state===true && mode === 'view'">
  </div>
  <el-dialog :style="dialogStyle"
      title="子窗口页面"
      :visible.sync="modalShow"
      :width="realtimeData.modalValue+'px'"
      @close="modalShow=false"
      append-to-body>
    <div :style="modelStyle">
      <div style="width: 100%; ">
        <the-create style="width: 100%;" :companyId="companyId" :productId="realtimeData.pageId" :projectId="productSaveForm.projectId" :editType="3" :dialogCount="dialogCount+1" :readPublished="true"></the-create>
      </div>
    </div>
  </el-dialog>

</div>
</template>

<script>
	import componentsMixin from "../componentsMixin";
	export default {
    name: 'crossTwoComponent',
    mixins: [componentsMixin],
			data(){
				return{
				}
			},
			methods: {
			},
			watch:{
        // 'realtimeData.top': {  // x绑定
        //   handler() {
        //     this.wrapperStyle.top = this.realtimeData.top +'px'
        //   }
        // },
        // 'realtimeData.left': {  // y绑定
        //   handler() {
        //     this.wrapperStyle.left = this.realtimeData.left +'px'
        //   }
        // },
        // 'realtimeData.height': {  // 高度绑定
        //   handler() {
        //     this._style.height = this.realtimeData.height + 'px'  // componentsMixin 中对 _style 进行了检查更新style 绑定至矩形框
        //     this.wrapperStyle.height = this.realtimeData.height +'px'
        //   }
        // },
        // 'realtimeData.width': {  // 宽度绑定
        //   handler() {
        //     console.log("宽度发生改变",this.realtimeData.width,this.style)
        //     this._style.width = this.realtimeData.width + 'px'
        //     this.wrapperStyle.width = this.realtimeData.width +'px'  // 编辑框
        //   }
        // },
			},
    computed:{
      dialogStyle(){
        if(this.realtimeData.modalX === undefined && this.realtimeData.modalY === undefined ){
          var applyLeft = '0'
          var applyTop = '0'
        }else if(this.realtimeData.modalX.length == 0 && this.realtimeData.modalY.length == 0){
          var applyLeft = '0'
          var applyTop = '0'
        }else if(this.realtimeData.modalX.length !== 0 && this.realtimeData.modalY.length == 0){
          var applyLeft = this.realtimeData.modalX
          var applyTop = '0'
        } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length == 0) {
          var applyLeft = '0'
          var applyTop = this.realtimeData.modalY
        } else if (this.realtimeData.modalY.length !== 0 && this.realtimeData.modalX.length !== 0) {
          var applyLeft = this.realtimeData.modalX
          var applyTop = this.realtimeData.modalY
        }
        return {
          top:`calc(${applyTop}px + 10vh)`,
          left: applyLeft + 'px',
        }
      },
      // style1() {
      //   let res = {};
      //   res['background'] = 'linear-gradient(to bottom,' + this.realtimeData.pipelineColor+ ', rgba(255,0,0,0),'+this.realtimeData.pipelineColor+  ')';
      //   return res;
      // },
    }
	}
</script>

<style lang="less" scoped>
	.cross {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
	}
  .rowx{
    width: 100%;
    height: 100%;
    background: white;
    position: relative;
  }
  .row1x{
    width: 100%;
    height: 100%;
    position: relative;

  }
  ::v-deep .el-dialog{
    margin:0 !important;
    position:absolute;
  }
</style>
